import axios from 'axios'


//http://siebck.ecosysb.ecowas.int/
//http://localhost/siebck/
/*export const endpointBck = 'http://localhost/siebck/';
export const endpointFrt = 'http://localhost:3000/';
export const endpoint = 'http://localhost/siebck/api/';
export const endpointImg = 'http://localhost/siebck/public/assets/images/';*/


/*export const endpointBck = 'https://siebck.ecosysb.ecowas.int/';
export const endpointFrt = 'https://siefront.ecosysb.ecowas.int/';
export const endpoint = 'https://siebck.ecosysb.ecowas.int/api/';
export const endpointImg = 'https://siebck.ecosysb.ecowas.int/public/assets/images/';*/

/*export const endpointBck = 'https://sietogo.ecosysb.ecowas.int/';
export const endpointFrt = 'https://sie-togo.ecosysb.ecowas.int/';
export const endpoint = 'https://sietogo.ecosysb.ecowas.int/api/';
export const endpointImg = 'https://sietogo.ecosysb.ecowas.int/public/assets/images/';*/



export const  endpointBck = process.env.REACT_APP_ENDPOINT_BCK;
export const  endpointFrt = process.env.REACT_APP_ENDPOINT_FRT;
export const  endpoint = process.env.REACT_APP_ENDPOINT;
export const  endpointImg = process.env.REACT_APP_ENDPOINT_IMG;
export const  TOKEN = process.env.REACT_APP_TOKEN;



//axios.defaults.headers.common['Accept'] = 'application/json';
//axios.defaults.headers.common['Content-type'] = 'application/json';
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
/*axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const token = localStorage.getItem('token');
if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    console.log(token)
}


export const apiClient = axios.create({
    baseURL: 'http://localhost/siebck',
    withCredentials: true,
})

export const setTokenLogin = apiClient.get('/sanctum/csrf-cookie')
    .then(response => {
        apiClient.post('/api/login', {
            email: 'ecowas@ecowas.int',
            password: 'password'
        }).then(response => {
            sessionStorage.setItem('loggedIn', true);
            localStorage.setItem('token', response.data.access_token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
            //console.log('l', response)
            return response;
        }).catch(error => {
            sessionStorage.setItem('loggedIn', false);
            localStorage.removeItem('token');
            axios.defaults.headers.common['Authorization'] = 'Bearer';
        });
    });



const logout = () => {
    apiClient.post('/logout').then(response => {
        if (response.status === 204) {
            //setLoggedIn(false);
            //sessionStorage.setItem('loggedIn', false);
        }
    })
};*/

axios.defaults.headers.common = {'Authorization': `Bearer ${TOKEN}`}


export const getActors=  () => axios.get(endpoint+'getactors')
export const getCountries =  () => axios.get(endpoint+'getcountries')

export const readCountry =  (id) => axios.get(endpoint + 'readCountry' + (id ? '/' + id : ''))
export const listNews =  () => axios.get(endpoint+'news')
export const listSlides =  () => axios.get(endpoint+'slides')
export const listDashInd =  () => axios.get(endpoint+'getdashbordind')
export const listIndicator =  () => axios.get(endpoint+'getindicator')
export const readNew = (id) => axios.get(endpoint+'getNew/'+id)
export const readDetBalance = (year, country) => axios.get(endpoint+'getdetbalancestat/'+year+'/'+country)
export const readLastDetBalance = () => axios.get(endpoint+'getlastdetbalancestat')
export const readSimpleBalance = (year, country) => axios.get(endpoint+'getsimpbalancestat/'+year+'/'+country)
export const readCombfgazmStat = (year, country) => axios.get(endpoint+'getcombfgazmstat/'+year+'/'+country)
export const readElecqstatStat = (year, country) => axios.get(endpoint+'getelecqstat/'+year+'/'+country)
export const readEnrbiomasseStat = (year, country) => axios.get(endpoint+'getenrbiomassestat/'+year+'/'+country)
export const readGaznaturalStat = (year, country) => axios.get(endpoint+'getgaznaturalstat/'+year+'/'+country)
export const readPetrolestat = (year, country) => axios.get(endpoint+'getpetrolestat/'+year+'/'+country)
export const readDashboardstat = (dashboard, country) => axios.get(endpoint+'rdashboardstat/'+dashboard+'/'+country)
export const readDashboardCompareStat = (dashboard) => axios.get(endpoint+'rdashboardcomparestat/'+dashboard)
export const readIndicatorStat = (indicator, country) => axios.get(endpoint+'rindicatorstat/'+indicator+'/'+country)
export const sendContact =  ({name, email, subject, message}) => axios.post(endpoint+'sendContact', {
    name,
    email,
    subject,
    message
})
export const hDashboardStat = (countryId) => {
    const url = endpoint + 'hdashboardstat';
    return countryId
        ? axios.get(url+'/'+countryId)
        : axios.get(url);
}
export const indicatorKey = (countryId) => {
    const url = endpoint + 'indicatorkey';
    return countryId
        ? axios.get(url+'/'+countryId)
        : axios.get(url);
}
export const getFactor = (toUnit) => axios.get(endpoint + 'get-factor/' + toUnit)
export const listPublishedSankeys = () => axios.get(`${endpoint}sankey/list`)
export const readSankey = (id, year, country) => {
    if (year && country) {
        return axios.get(`${endpoint}sankey/${id}/details?year=${year}&country=${country}`);
    } else if (year && !country) {
        return axios.get(`${endpoint}sankey/${id}/details?year=${year}`);
    } else if (!year && country) {
        return axios.get(`${endpoint}sankey/${id}/details?country=${country}`);
    } else {
        return axios.get(`${endpoint}sankey/${id}/details`);
    }  
}
export const readSankeyYears = (id) => axios.get(`${endpoint}sankey/${id}/years`)

